import { ExternalLink } from "lucide-react";
import { PhonePeBadge } from "./RailSelector";

// Two explicit link buttons (hrefs) — PAY VIA PHONEPE + PAY VIA RAZORPAY. For hosted-link flows (invoices, certificates, bookings).
export function DualPayLinks({ urls = {}, amountLabel = "", testId = "pay-links", size = "md", onPhonePe, onRazorpay, light = false }) {
  const pp = urls.phonepe, rz = urls.razorpay;
  if (!pp && !rz && !onPhonePe && !onRazorpay) return null;
  const pad = size === "sm" ? "px-4 py-2 text-[10px]" : "px-5 py-2.5 text-[10px]";
  const base = `rounded-full font-grotesk uppercase tracking-[0.2em] inline-flex items-center gap-2 whitespace-nowrap transition-all hover:brightness-110 ${pad}`;
  const Btn = ({ href, onClick, cls, id, children }) => href
    ? <a href={href} target="_blank" rel="noreferrer" data-testid={id} className={`${base} ${cls}`}>{children}<ExternalLink size={11} /></a>
    : <button type="button" onClick={onClick} data-testid={id} className={`${base} ${cls}`}>{children}</button>;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2">
      {(pp || onPhonePe) && (
        <Btn href={pp} onClick={onPhonePe} id={`${testId}-phonepe`} cls={light ? "bg-white text-[#5F259F]" : "bg-[#5F259F] text-white"}>
          <PhonePeBadge size={12} /> Pay via PhonePe{amountLabel ? ` · ${amountLabel}` : ""}
        </Btn>
      )}
      {(rz || onRazorpay) && (
        <Btn href={rz} onClick={onRazorpay} id={`${testId}-razorpay`} cls={light ? "bg-white text-[#7a1e15]" : "bg-[#D8B23E] text-black"}>
          Pay via Razorpay{amountLabel ? ` · ${amountLabel}` : ""}
        </Btn>
      )}
    </div>
  );
}

export const railUrls = (obj = {}, legacyRazorpay) => ({
  razorpay: obj?.pay_urls?.razorpay || legacyRazorpay || obj?.payment_link_url || null,
  phonepe: obj?.pay_urls?.phonepe || null,
});
